<template>
  <ElTable ref="elTableRef" :data="templates" style="width: 100%" class="overview-table config-table" row-key="id"
           lazy :load="expand" :row-class-name="tableRowClassName" :tree-props="{ hasChildren: 'hasSubitems' }"
           table-layout="auto" :default-sort="{ prop: 'templateNumber', order: 'descending' }"
           v-loading="loading" element-loading-custom-class="loadingTop"
  >
    <!-- ══ DIE NEUESTE VORLAGE STEHT OBEN ════════════════════════════════
         Vorgabe des Betreibers 03.10.2026: „Kannst du bitte die Templates
         nach der Nummer sortieren, abfallend, also höchste Nummer oben."
         Bei fünfundsiebzig Vorlagen sucht man die, an der man gerade
         arbeitet — und das ist die mit der höchsten Nummer.

         `sort-by` RECHNET, statt Zeichen zu vergleichen: Fehlt einer alten
         Vorlage die Nummer, stünde sie sonst unvorhersehbar irgendwo. -->
    <ElTableColumn prop="templateNumber" label="Nr." width="64" sortable
                   :sort-by="(r: any) => Number(r.templateNumber ?? 0)"></ElTableColumn>
    <ElTableColumn prop="name" label="Name" sortable></ElTableColumn>
    <ElTableColumn label="Version" width="84" sortable :sort-by="(r: any) => r.version || 0">
      <template #default="scope">
        <span v-if="scope.row.version != null && !String(scope.row.id).includes('-add')">v{{ scope.row.version }}</span>
      </template>
    </ElTableColumn>
    <ElTableColumn label="Kategorie" sortable>
      <template #default="scope">
        {{ getTemplateCategoryName(scope.row) }}
      </template>
    </ElTableColumn>
    <ElTableColumn label="Beschreibung">
      <template #default="scope">
        <div v-html="scope.row.description"></div>
      </template>
    </ElTableColumn>
    <ElTableColumn label="Organisationen">
      <template #default="scope">
        <div v-html="getOrganisationsAsString(scope.row)"></div>
      </template>
    </ElTableColumn>
    <ElTableColumn prop="created" label="Erstellungsdatum" :formatter="dateFormatter" sortable></ElTableColumn>
    <ElTableColumn label="" min-width="270px">
      <template #default="scope">
        <div v-if="~scope.row.id.indexOf('-add')" class="d-flex justify-content-end w-100">
          <BaseButton type="primary" @click="createNewDbTemplate(scope.row.parent)">
            Sub-Template hinzufügen
          </BaseButton>
        </div>
        <div v-else class="actions">
          <NuxtLink :to="`/dashboard/datenbank-templates/${scope.row.id}`">
            <BaseButton title="Einstellungen" type="primary" icon><i class="material-icons">settings</i></BaseButton>
          </NuxtLink>
          <BaseButton title="Template duplizieren" type="primary" icon @click="copyTemplate(scope.row)">
            <i class="material-icons">content_copy</i>
          </BaseButton>
          <NuxtLink :to="`/dashboard/datenbank-templates/${scope.row.id}/preview`">
            <BaseButton type="primary" icon><i class="material-icons">remove_red_eye</i></BaseButton>
          </NuxtLink>
          <BaseButton title="Verwendende Datenbanken" type="primary" icon @click="showUsages(scope.row)">
            <i class="fa fa-list-tree"></i>
          </BaseButton>
          <BaseButton title="Kindtemplates" v-if="!scope.row.parent" type="primary" icon @click="toggle(scope.row)">
            <i class="fa" :class="scope.row.hasChildren ? 'fa-chart-network' : 'fa-link-horizontal'"></i>
          </BaseButton>
          <div v-else></div>
          <BaseButton title="Template löschen" type="primary" icon @click="handleDelete(scope.row)">
            <i class="material-icons">delete</i>
          </BaseButton>
        </div>
      </template>
    </ElTableColumn>
  </ElTable>
</template>

<script lang="ts" setup>
import { DatabaseTemplate } from '~/api-client';

const elTableRef = ref<any>(null);
defineExpose({ elTableRef });

defineProps({
  templates: { type: Array as () => DatabaseTemplate[], required: true },
  expand: { type: Function, required: true },
  toggle: { type: Function, required: true },
  dateFormatter: { type: Function, required: true },
  getTemplateCategoryName: { type: Function, required: true },
  getOrganisationsAsString: { type: Function, required: true },
  createNewDbTemplate: { type: Function, required: true },
  copyTemplate: { type: Function, required: true },
  handleDelete: { type: Function, required: true },
  showUsages: { type: Function, required: true },
  loading: { type: Boolean, default: false },
});

const tableRowClassName = ({ row, rowIndex }: { row: DatabaseTemplate, rowIndex: number }) => {
  return rowIndex % 2 === 1 ? 'row-odd' : undefined;
};
</script>

<style lang="scss" scoped>
.actions {
  display: grid;
  grid-template-columns: repeat(6, 40px);
  width: fit-content;
  margin-left: auto;
  gap: 4px;
}
</style>
